var colors = require('../colors');

module['exports'] = function (letter, i, exploded) {
  return i % 2 === 0 ? letter : colors.inverse(letter);
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/colors/lib/maps/zebra.js
 ** module id = 114
 ** module chunks = 0
 **/